export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1768_.244620d4.jpg";